import React from 'react';
import styled from 'styled-components';

type Props = {
    children: string,
}

const H2 = (props: Props) => {
    return (
        <H2WithStyled { ...props }>
            { props.children }
        </H2WithStyled>
    );
};

const H2WithStyled = styled.h2`
    border-left: 5px solid orange;
    border-bottom: 1px dashed #ccc;
    padding: 10px;
    margin: 0;
    font-size: 18px;
    font-weight: bold;
`

export default H2;